import React from "react";
import { Crown, Star } from "lucide-react";

// Shared VIP/Founder badge renderer used by the Leaderboard and EndScreen.
// Priority: Founder > VIP > nothing. Reads existing fields, no fetches.
export default function PlayerBadge({ isFounder, isVip, size = 11 }) {
  if (isFounder) {
    return (
      <span className="player-badge player-badge-founder" title="Founder" data-testid="player-badge-founder">
        <Crown size={size} strokeWidth={2.6} /> FOUNDER
      </span>
    );
  }
  if (isVip) {
    return (
      <span className="player-badge player-badge-vip" title="VIP" data-testid="player-badge-vip">
        <Star size={size} strokeWidth={2.6} /> VIP
      </span>
    );
  }
  return null;
}
